import { Layout, SEO } from '@components/common'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import TheBlogDesktop from '@publicAssets/images/ui/blog/TheBlogDesktop.webp'
import TheBlogDesktop2 from '@publicAssets/images/ui/blog/TheBlogDesktop2.webp'
import TheBlogMobile from '@publicAssets/images/ui/blog/TheBlogMobile.webp'

const BlogCardContainer = dynamic(
  () => import('@components/yadav/common/Blog/BlogCardContainer')
)

export default function Blog() {
  return (
    <>
      <SEO
        title="Yadav Blog - Stay Informed On All of the Latest Trends | Yadav Diamonds and Jewelry"
        description="Stay informed with Yadav's Blog - Get insights, trends, and expert tips on jewelry and gemstones. Explore our latest articles for the ultimate style inspiration!"
      />
      <div className='hidden 2xl:block relative mx-auto max-w-[1782px] min-h-[835px] mb-[89px]'>
        <Image
            priority
            objectFit="cover"
            quality={95}
            layout="fill"
            src={TheBlogDesktop}
            alt="The Blog"
          />
      </div>

      <div className='hidden md:block 2xl:hidden relative mx-auto max-w-[1369px] min-h-[591px] mb-[71px]'>
        <Image
          priority
          objectFit="cover"
          quality={95}
          layout="fill"
          src={TheBlogDesktop2}
          alt="The Blog"
        />
      </div>

      <div className='block md:hidden relative mx-auto max-w-[430px] min-h-[430px] mb-[36px]'>
        <Image
            priority
            objectFit="cover"
            quality={95}
            layout="fill"
            src={TheBlogMobile}
            alt="The Blog"
          />
      </div>
      <BlogCardContainer section="Yadav Blog" subsections={null} />
    </>
  )
}

Blog.Layout = Layout
